export default "__VITE_PUBLIC_ASSET__2c5c8586__"